import { jsxs, jsx } from "react/jsx-runtime";
const IconCommentsSvg = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: 16,
    height: 16,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "M17.175 15.992a5.832 5.832 0 0 0-2.283-8.809 6.667 6.667 0 1 0-11.825 5.242l-1.158 1.15a.833.833 0 0 0-.175.908A.833.833 0 0 0 2.5 15h4.742a5.833 5.833 0 0 0 5.258 3.333h5a.834.834 0 0 0 .767-.516.834.834 0 0 0-.175-.909l-.917-.916ZM6.667 12.5c.001.28.024.558.067.833H4.509l.291-.283a.833.833 0 0 0 0-1.183 4.942 4.942 0 0 1-1.466-3.534 5 5 0 0 1 5-5 4.95 4.95 0 0 1 4.708 3.334H12.5A5.833 5.833 0 0 0 6.667 12.5Zm8.783 4.167.042.041H12.5a4.166 4.166 0 1 1 2.95-1.216.834.834 0 0 0-.25.583.834.834 0 0 0 .25.592Z" })
    ]
  }
);
export {
  IconCommentsSvg
};
